module.exports = __webpack_public_path__ + "img/loading-small.9244a600.png";